import { createSlice } from '@reduxjs/toolkit';
import { getDiskGuideTipsInfo, transDiskPrivileges } from '@web-disk/disk';
const InitialState = {
    curSideTab: 'recently',
    curRootInfo: {},
    curContWidth: 0,
    curDirId: -7,
    guideTipsInfo: getDiskGuideTipsInfo(),
    curSpaceState: {
        private: 'uninitial',
        public: 'uninitial',
    },
    isNewUser: false,
    curUploadFileItems: [],
    curUploadTriggerInfo: undefined,
    diskPs: null,
    diskPsR: {
        public: [],
        private: [],
    },
    allowDoc: false,
};
const diskSlice = createSlice({
    name: 'diskReducer',
    initialState: InitialState,
    reducers: {
        setCurSideTab: (state, action) => {
            state.curSideTab = action.payload;
        },
        setCurRootInfo: (state, action) => {
            state.curRootInfo = action.payload;
        },
        resetSpaceState: state => {
            state.curSpaceState = {
                private: 'uninitial',
                public: 'uninitial',
            };
        },
        setSpaceState: (state, action) => {
            state.curSpaceState = Object.assign(Object.assign({}, state.curSpaceState), action.payload);
        },
        setCurContWidth: (state, action) => {
            state.curContWidth = action.payload;
        },
        setCurDirId: (state, action) => {
            console.log('test', action);
            state.curDirId = action.payload;
        },
        setGuideTipsInfo: (state, action) => {
            state.guideTipsInfo = action.payload;
        },
        setGuideTipsInfoByKey: (state, action) => {
            state.guideTipsInfo = Object.assign(Object.assign({}, state.guideTipsInfo), { [action.payload.key]: action.payload.value });
        },
        setIsNewUser: (state, action) => {
            state.isNewUser = action.payload;
        },
        setCurUploadFileItems: (state, action) => {
            state.curUploadFileItems = action.payload;
        },
        setCurUploadTriggerInfo: (state, action) => {
            state.curUploadTriggerInfo = action.payload;
        },
        setDiskPs: (state, action) => {
            state.diskPs = action.payload;
            state.diskPsR = transDiskPrivileges(state.diskPs || []);
        },
        setAllowDoc: (state, action) => {
            state.allowDoc = action.payload;
        },
    },
});
export const { actions } = diskSlice;
export default diskSlice.reducer;
